module.exports = __webpack_public_path__ + "static/img/cloud.949e9d00.png";